module.exports = __webpack_public_path__ + "img/home1.a37c8f55.png";